<template>
  <dialogModule
    top="3"
    width="90%"
    :title="$t('returnGoods.title')"
    v-if="salesVisible"
    :closeOnPressEscape="false"
    :dialogVisible="salesVisible"
    @close="close">
    <span slot="close" class="el-icon-close close-icon" @click="close"></span>
    <div slot="content" class="return-box">
      <div style="position: absolute; left: 10%; top: -30px; color: red; font-size: 16px; font-weight: bold">
        <span>{{$t('returnGoods.priceTips')}}</span>
      </div>
      <section
        class="row"
        v-loading="fetchLoading"
        :element-loading-text="$t('returnGoods.loading')"
        element-loading-spinner="el-icon-loading">
        <div class="return-table">
          <grid-manager :option="gridOption"></grid-manager>
        </div>
        <div class="info-right">
          <div class="active-list" v-if="activeList.length || couponOrderDetailPojoList.length">
            <template v-if="activeList.length">
            <div class="active-info" v-for="item in activeList" :key="item.activityName">
              <p class="column">
                <span>{{ item.typeDesc }}</span>
                <i>{{ item.activityName }}</i>
              </p>
              <div class="row align-center space-between active-goods">
                <div class="row goods-all">
                  <div class="goods-relative" v-for="(goods, a) in item.list" :key="a">
                    <el-image
                      v-if="goods.imageList"
                      class="goods-image"
                      :src="goods.imageList[0]"
                      :preview-src-list="goods.imageList"></el-image>
                    <div v-else class="goods-image row space-center align-center">{{$t('returnGoods.noGoodsImage')}}</div>
                    <span>{{ goods.goodsNo }}</span>
                    <div class="active-num">{{$t('returnGoods.barCodeCount', {count: goods.number})}}</div>
                    <div
                      :class="['active-type', goods.isAddBuy ? 'add-buy' : '', goods.isGift ? 'gift' : '', 'activity']">
                      {{ goods.isAddBuy ? $t('returnGoods.addBuy') : goods.isGift ? $t('returnGoods.gift') : $t('returnGoods.activity') }}
                    </div>
                  </div>
                </div>
                <div class="cursor row align-center" @click="showAll(item, 'act')">
                  <div style="width: 40px;">{{$t('returnGoods.goodsNoCount', {count: item.list.length})}}</div>
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div style="padding: 5px 10px;color:#666;" v-if="item.returnDiscount || item.returnPriceType">
                <div>{{$t('returnGoods.partialDiscount')}}：<span style="color: #000;font-weight: bold;">{{item.returnDiscount}}</span></div>
                <div>{{$t('returnGoods.partialPriceType')}}：<span style="color: #000;font-weight: bold;">{{item.returnPriceType}}</span></div>
              </div>
            </div>
            </template>
            <template v-if="couponOrderDetailPojoList.length">
            <div class="active-info" v-for="item in couponOrderDetailPojoList" :key="item.certificateId">
              <p><span style="color: #722ED1;font-weight: bolder;font-size: 18px;">{{item.couponTypeDesc}}</span><i>{{item.couponName}}</i></p>
              <div class="row align-center space-between active-goods">
                <div class="row goods-all">
                  <div class="goods-relative" v-for="(goods, a) in item.goodInfos" :key="a + goods.goodsNo">
                    <el-image v-if="goods.imageList" class="goods-image" :src="goods.imageList[0]" :preview-src-list="goods.imageList"></el-image>
                    <div v-else class="goods-image row space-center align-center">{{$t('returnGoods.noGoodsImage')}}</div>
                    <span>{{ goods.goodsNo }}</span>
                    <div class="active-num">{{$t('returnGoods.barCodeCount', {count: goods.number})}}</div>
                  </div>
                  <div class="goods-relative" v-for="(goods, a) in item.giftGoodInfos" :key="a">
                    <el-image v-if="goods.imageList" class="goods-image" :src="goods.imageList[0]" :preview-src-list="goods.imageList"></el-image>
                    <div v-else class="goods-image row space-center align-center">{{$t('returnGoods.noGoodsImage')}}</div>
                    <span>{{ goods.goodsNo }}</span>
                    <div class="active-num">{{$t('returnGoods.barCodeCount', {count: goods.number})}}</div>
                    <div class="active-type gift">{{$t('returnGoods.gift')}}</div>
                  </div>
                </div>
                <div v-if="(item.goodInfos && item.goodInfos.length) || (item.giftGoodInfos && item.giftGoodInfos.length)" class="cursor" @click="showAll(item, 'tic')">
                  {{$t('returnGoods.goodsNoCount', {count: (item.goodInfos && item.goodInfos.length || 0) + (item.giftGoodInfos && item.giftGoodInfos.length || 0) })}}
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
              <div style="padding: 5px 0 5px 10px;">{{$t('returnGoods.couponReturnTotal')}}：<span style="color: #000;font-weight: bold;">{{item.returnAmount}}</span></div>
            </div>
            </template>
          </div>
          <div class="return-info">
            <p class="return-title">{{$t('returnGoods.infoTitle')}}</p>
            <div class="info-line">
              <span>{{$t('returnGoods.originalOrder')}}：</span>
              <span>{{ otherInfo.innerSn }}</span>
            </div>
            <div class="info-line">
              <span>{{$t('returnGoods.salesman')}}：</span>
              <span>{{ otherInfo.userName }}</span>
              <span class="public-order" v-if="otherInfo.isPublic === 'Y'">{{$t('returnGoods.publicOrder')}}</span>
            </div>
            <div class="info-line" v-if="otherInfo.crmPhone">
              <span>{{$t('returnGoods.member')}}：</span>
              <span
                >{{ otherInfo.crmUserName }}&nbsp;&nbsp;&nbsp;{{
                  otherInfo.crmPhone.substr(0, 3) + '****' + otherInfo.crmPhone.substr(7)
                }}</span
              >
            </div>
            <div class="old-money border-bottom">
              <div>{{$t('returnGoods.originalLatestAmount')}}：<i>{{ otherInfo.newOrderPrice || '0.00' }}đ</i></div>
              <div>{{$t('returnGoods.salesQuantity')}}：<i>{{ otherInfo.number || '0' }}</i></div>
            </div>
            <div class="old-money">
              <div>{{$t('returnGoods.defaultReturnTotal')}}：<i>{{ reduceResult.defaultTotalAmount || '0.00' }}đ</i></div>
              <div>{{$t('returnGoods.returnQuantity')}}：<i>{{ reduceResult.numTotal || '0' }}</i></div>
            </div>
            <div class="old-money">
              <div>{{$t('returnGoods.refundAmount')}}：<i>{{ reduceResult.realTotalAmount || '0.00' }}đ</i></div>
            </div>
            <div class="return-reason">
              <p><span>*</span>{{$t('returnGoods.returnReason')}}：</p>
              <el-input type="textarea" :placeholder="$t('returnGoods.pleaseInput')" resize="none" rows="3" v-model="description"></el-input>
            </div>
          </div>
          <el-button class="return-btn" type="primary" :loading="fetchLoading" @click="submitBefore">{{$t('returnGoods.confirmReturn')}}</el-button>
        </div>
      </section>
      <ActiveGoodsList v-if="activeInfoVisible" :activeObject="activeObject" @close="activeInfoVisible = false"></ActiveGoodsList>
      <ReturnChangePrice
        v-if="changePriceVisible"
        :approveList="approveList"
        :approveInfo="approveInfo"
        :tableData="tableData"
        :hrFlowTypeId="hrFlowTypeId"
        :reduceResult="reduceResult"
        :snNo="otherInfo.innerSn"
        :ticketInfoList="couponRetreatInfos"
        @close="changePriceVisible = false"
        @sure="approveSubmit">
      </ReturnChangePrice>
      <TicketGoods v-if="TicketGoodsLog" :currentTicket="activeObject" @close="TicketGoodsLog = false"></TicketGoods>
    </div>
  </dialogModule>
</template>

<script>
import ReturnChangePrice from './ReturnChangePrice'
import dialogModule from '@/components/dialogModule.vue'
import TicketGoods from "@/views/deptCollectMoney/components/TicketGoods.vue"
import ActiveGoodsList from '@/views/deptCollectMoney/components/ActiveGoodsList.vue'
import { returnSalesActivity, returnSalesSubmit, salesAfterOperate } from '@/libs/http/modules/posOrder'
export default {
  name: 'returnGoods',
  props: {
    invoicesItem: {
      type: Object,
      default: () => null
    }
  },
  components: {
    dialogModule,
    TicketGoods,
    ActiveGoodsList,
    ReturnChangePrice
  },
  data() {
    return {
      salesVisible: true,
      fetchLoading: false,
      sell: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/sell.png") : require("@/assets/images/vnSell.png"),
      give: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/give.png") : require("@/assets/images/vnGave.png"),
      back: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/return.png") : require("@/assets/images/vnReturn.png"),
      rite: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/rite.png") : require("@/assets/images/vnGift.png"),
      ned: this.$cache.local.get('locale') === 'zh' ? require("@/assets/images/ned.png") : require("@/assets/images/vnChange.png"),
      gridOption: {
        gridManagerName: 'return-goods-table',
        firstLoading: true,
        height: '85vh',
        isCombSorting: true,
        supportAutoOrder: false,
        supportCheckbox: true,
        supportMenu: false,
        supportConfig: true,
        disableAutoLoading: true,
        disableBorder: false,
        disableLine: true,
        checkboxConfig: {
          width: 50
        },
        columnData: [
          {
            key: 'operationType',
            text: this.$t('gridManage.columnType'),
            align: 'center',
            width: '100px',
            template: () => {
              return `
								<div>
                  <img style="width:40px;height:40px;" v-if="row.operationType === '1'" :src="sell" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '2'" :src="give" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '4'" :src="back" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '3'" :src="rite" />
                  <img style="width:40px;height:40px;" v-if="row.operationType === '6'" :src="ned" />
								</div>
						    `
            }
          },
          {
            key: 'goodsInfo',
            text: this.$t('gridManage.columnGoodsInfo'),
            align: 'center',
            width: '350px',
            template: () => {
              return `
								<div class="row" style="text-align:left;">
									<div style="width:102px;height:92px;margin-right:10px;position: relative;overflow: hidden;">
										<el-image v-if="row.imageList && row.imageList.length" style="width:102px;height:92px;border-radius:4px;" :preview-src-list="row.imageList" :src="row.imageList[0]"></el-image>
								    <div v-else class="row align-center space-center" style="background: #eee;width:102px;height:92px;border-radius:4px;color: #999;text-align: center;white-space: pre-wrap;">{{$t('gridManage.noGoodsImage')}}</div>
                      <div v-if="row.activityId || row.isExchange === 1 || row.operationType === '2' || row.couponInfoId || row.certificateId"
                          style="position: absolute;left: 48px;top: 10px;width:70px;line-height: 18px;color:#fff;transform: rotate(45deg);text-align: center;font-size: 8px;"
                        :style="row.isExchange === 1 ? 'background: linear-gradient(0deg, rgb(116,47,169), rgb(101,41,147), rgb(72,30,105))' : row.operationType === '2' ? 'background: linear-gradient(0deg, #208AEC, #02D7F0, #00C6F7)' : 'background: linear-gradient(-90deg, #EC4620, #F08702, #F7D400)'">
                          <span>{{row.isExchange === 1 ? $t('gridManage.addBuy') : row.operationType === '2' ? $t('gridManage.gave') : row.activityId ? $t('gridManage.activity') : $t('gridManage.writeOff')}}</span>
                      </div>
								    </div>
								    <div class="column" style="height:90px;width: calc(100% - 112px);">
                      <template v-if="row.couponInfoId">
                        <div>{{row.couponTypeDesc}}</div>
                        <div style="width: 100%;white-space: pre-wrap;">{{row.couponName}}</div>
                      </template>
                      <template v-else>
                        <div style="font-size:18px;color:#333;">{{row.goodsName}}</div>
                        <div style="font-size:14px;color:#999;margin: 10px 0;">{{$t('gridManage.goodsNo')}}：{{row.goodsNo}}</div>
                        <div style="font-size:14px;color:#999;">{{$t('gridManage.goodsBarCode')}}：{{row.barCode}}</div>
                      </template>
								    </div>
								</div>
							`
            }
          },
          {
            key: 'attr',
            text: this.$t('gridManage.columnAttr'),
            align: 'center',
            width: '140px',
            template: () => {
              return `
								<div v-if="row.attr" class="row space-center align-center text-center" style="border:1px solid #DEEEF9;background:#fff;line-height:34px;border-radius:2px;">
									<p v-for="(item, index) in row.attr.slice(0,2)" :key="item.code">{{item.value}}
									  	<span v-if="index == 0" style="margin:0 3px;">,</span>
									</p>
							  </div>
                <div v-else class="row space-center align-center" style="width: 100px;"></div>
              `
            }
          },
          {
            key: 'realPrice',
            text: this.$t('gridManage.originalPrice'),
            align: 'center',
            width: '120px',
            template: () => {
              return `
								<div style="font-size: 16px;">{{row.realPrice}}đ</div>
						    `
            }
          },
          {
            key: 'number',
            text: this.$t('gridManage.number'),
            align: 'center',
            width: '120px',
            template: () => {
              return `
								<div v-if="!row.couponInfoId" style="font-size: 16px;">{{row.number}}</div>
							`
            }
          },
          {
            key: 'totalPrice',
            text: this.$t('gridManage.totalPrice'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
								<div v-if="!row.couponInfoId" style="color:#F8475F;font-size: 18px;">{{row.totalPrice}}đ</div>
						    `
            }
          },
          {
            key: 'originPrice',
            text: this.$t('gridManage.currentSellPrice'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
								<div v-if="!row.couponInfoId" style="font-size: 16px;">{{row.originPrice}}đ</div>
							`
            }
          },
          {
            key: 'fixedRetreatPrice',
            text: this.$t('gridManage.fixedRetreatPrice'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
                <div>
                    <div style="font-size: 16px;">{{row.fixedRetreatPrice || '0.00'}}đ</div>
                    <div v-if="row.isHasActivityDiscount === 'Y'" style="width:80px;height:20px;background:#ffa940;color:#fff;margin: auto;">{{$t('gridManage.partReturnPrice')}}</div>
                </div>
							`
            }
          },
          {
            key: 'retreatPrice',
            text: this.$t('gridManage.retreatPrice'),
            align: 'center',
            width: '160px',
            template: () => {
              return `
								<div> 
								  	<input
								  	type="text"
								  	:disabled="row.isChangePrice !=='Y'"
								  	v-model="row.retreatPrice"
								  	@change="changePrice(row, index)"
								  	@input="row.retreatPrice=row.retreatPrice.replace(/^([0-9-]\\d*\\.?\\d{0,2})?.*$/,'$1')"
								  	style="width:120px;height:36px;line-height:36px;text-align:center;border:1px solid #eee;color:#333;outline:none;font-size:18px;">
                    <span style="font-size: 16px;">đ</span>
								  	<div @click="recoverPrice(row, index)" v-if="row.isUpdatePrice === 'Y'" class="row space-between align-center" style="background: rgb(255, 144, 0);color: #fff;width: 118px;margin-left: 2px;font-size: 10px;padding: 0 10px;">
								  	    <span>{{$t('gridManage.alreadyChangePrice')}}</span>
								  	    <span style="margin-left:5px;" class="el-icon-close"></span>
                    </div>
								</div>
						    `
            }
          },
          {
            key: 'retreatNumber',
            text: this.$t('gridManage.retreatNumber'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
                <div v-if="row.couponInfoId" class="row space-center align-center" style="height:40px;line-height:40px;text-align: center;background: #0b83f3;border-radius: 4px;color: #fff;" @click="showAll(row, 'tic')">{{$t('gridManage.showGoods')}}({{row.number}})</div>
								<div v-else class="row align-center space-center">
									<div v-if="row.isChangeNumber ==='Y'" style="width:40px;height:40px;line-height:40px;text-align:center;font-size:18px;border:1px solid #eee;cursor:pointer;font-weight: bold;" @click="minusHandel(row, index)">
									  	<span class="el-icon-minus"></span>
									</div>
									<div v-else style="width:40px;height:40px;line-height:40px;text-align:center;font-size:18px;font-weight: bold;background: #eee;color:#ddd;">
										<span class="el-icon-minus"></span>
									</div>
									<input
									  type="text"
								  	:disabled="row.isChangeNumber !=='Y'"
                    v-model="row.retreatNumber"
                    @change="blurHandel(row, index)"
                    @input="row.retreatNumber=row.retreatNumber.replace(/^0|[^0-9]/g,'')"
                    style="width:50px;height:40px;line-height:40px;text-align:center;border:1px solid #eee;border-left:none;color:#333;outline:none;font-size:18px;" />
									<div v-if="row.isChangeNumber ==='Y'" style="background:#067CF2;color:#fff;width:40px;height:40px;line-height:40px;text-align:center;font-size:18px;cursor:pointer;font-weight: bold;" @click="plusHandel(row, index)">
									  	<span class="el-icon-plus"></span>
									</div>
									<div v-else style="background:#eee;color:#ddd;width:40px;height:40px;line-height:40px;text-align:center;font-size:18px;font-weight: bold;">
									  	<span class="el-icon-plus"></span>
									</div>
                </div>
							`
            }
          },
          {
            key: 'totalRetreatPrice',
            text: this.$t('gridManage.totalRetreatPrice'),
            align: 'center',
            width: '150px',
            template: () => {
              return `
								<div style="color:#F8475F;font-size: 18px;">{{row.totalRetreatPrice}}đ</div>
						    `
            }
          }
        ],
        ajaxData: this.showGoodsTable,
        cellClick: this.cellClick,
        checkedAllAfter: this.checkedAllAfter
      },
      activeInfoVisible: false,
      activeObject: null,
      tableData: [],
      goodInfos: [],
      description: '',
      reduceResult: {},
      otherInfo: {},
      activeList: [],
      changePriceVisible: false,
      approveList: [],
      approveInfo: {},
      hrFlowTypeId: '',
      hasAlterPriceInfo: '',
      isAllowNegativeStocks: '',
      couponRetreatInfos: [],
      TicketGoodsLog: false,
      ticketInfoList: [],
      couponOrderDetailPojoList: []
    }
  },
  created() {
    let operateGoodInfo = {
      alterGoodsWay: '4'
    }
    this.operateList(operateGoodInfo)
    this.fetchActive()
  },
  methods: {
    close() {
      this.salesVisible = false
      this.$emit('close')
    },
    showGoodsTable() {
      return new Promise((resolve, reject) => {
        const tableData = {
          data: this.tableData
        }
        resolve(tableData)
      })
    },
    fetchActive() {
      returnSalesActivity({
        id: this.invoicesItem.id
      }).then(res => {
        if (res) {
          this.otherInfo = {
            isWeek: res.isWeek,
            number: res.number,
            innerSn: res.innerSn,
            isPublic: res.isPublic,
            crmPhone: res.crmPhone,
            userName: res.userName,
            crmUserName: res.crmUserName,
            newOrderPrice: res.newOrderPrice
          }
          res.activityOrderDetailPojoList.forEach(item => {
            this.$set(item, 'list', [])
            this.$set(item, 'isGoods', true)
            if (item.goodInfos && item.goodInfos.length) {
              item.list = item.list.concat(item.goodInfos)
            }
            if (item.addGoodInfos && item.addGoodInfos.length) {
              item.addGoodInfos.forEach(gave => {
                this.$set(gave, 'isAddBuy', true)
              })
              item.list = item.list.concat(item.addGoodInfos)
            }
            if (item.giftGoodInfos && item.giftGoodInfos.length) {
              item.giftGoodInfos.forEach(gift => {
                this.$set(gift, 'isGift', true)
              })
              item.list = item.list.concat(item.giftGoodInfos)
            }
          })
          this.activeList = res.activityOrderDetailPojoList
          this.couponOrderDetailPojoList = res.couponOrderDetailPojoList || []
        }
      }).catch(error => {
        this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
      })
    },
    cellClick(rowData, rowIndex, colIndex) {
      if (colIndex !== 0) return
      if (rowData.isSelect === 'N') {
        if (rowData.activityId) {
          if (rowData.activityType.toString() === '2') {
            let operateGoodInfo = {
              index: rowIndex,
              alterGoodsWay: '1',
              barCode: rowData.barCode
            }
            this.operateList(operateGoodInfo)
          } else {
            let operateGoodInfo = {
              index: rowIndex,
              alterGoodsWay: '1',
              barCode: rowData.barCode
            }
            this.operateList(operateGoodInfo)
          }
        } else {
          let operateGoodInfo = {
            alterGoodsWay: '1'
          }
          if(rowData.couponInfoId){
            operateGoodInfo['certificateId'] = rowData.certificateId
          }else{
            operateGoodInfo['index'] = rowIndex
            operateGoodInfo['barCode'] = rowData.barCode
          }
          this.operateList(operateGoodInfo)
        }
      } else {
        let operateGoodInfo = {
          alterGoodsWay: '2'
        }
        if(rowData.couponInfoId){
          operateGoodInfo['certificateId'] = rowData.certificateId
        }else{
          operateGoodInfo['index'] = rowIndex
          operateGoodInfo['barCode'] = rowData.barCode
        }
        this.operateList(operateGoodInfo)
      }
    },
    setChecked() {
      const checkList = this.tableData.filter(item => {
        return item.isSelect === 'Y'
      })
      GridManager.setCheckedData(this.gridOption.gridManagerName, checkList)
      GridManager.refreshGrid(this.gridOption.gridManagerName)
    },
    checkedAllAfter(checkedList, isChecked) {
      let operateGoodInfo = {
        isCheckAll: 'Y',
        alterGoodsWay: isChecked ? '1' : '2'
      }
      this.operateList(operateGoodInfo)
    },
    changePrice(row, idx) {
      let operateGoodInfo = {
        index: idx,
        alterGoodsWay: '3',
        barCode: row.barCode,
        price: row.retreatPrice
      }
      this.operateList(operateGoodInfo)
    },
    plusHandel(row, idx) {
      if (Number(row.retreatNumber) >= Number(row.number)) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({ showClose: true, message: this.$t('returnGoods.returnNotBigBuy'), type: 'error', duration: 2000 })
      }
      let operateGoodInfo = {
        index: idx,
        barCode: row.barCode,
        number: ++row.retreatNumber,
        alterGoodsWay: '3'
      }
      this.operateList(operateGoodInfo)
    },
    minusHandel(row, idx) {
      if (Number(row.retreatNumber) <= 1) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({ showClose: true, message: this.$t('returnGoods.returnNotMiniOne'), type: 'error', duration: 2000 })
      }
      let operateGoodInfo = {
        index: idx,
        barCode: row.barCode,
        number: --row.retreatNumber,
        alterGoodsWay: '3'
      }
      this.operateList(operateGoodInfo)
    },
    blurHandel(row, idx) {
      if (row.retreatNumber % 1 !== 0 || !row.retreatNumber || Number(row.retreatNumber) > Number(row.number)) {
        GridManager.renderGrid(this.gridOption.gridManagerName)
        return this.$message({
          showClose: true,
          message: this.$t('returnGoods.returnOneBuy'),
          type: 'error',
          duration: 2000
        })
      }
      let operateGoodInfo = {
        index: idx,
        barCode: row.barCode,
        number: row.retreatNumber,
        alterGoodsWay: '3'
      }
      this.operateList(operateGoodInfo)
    },
    recoverPrice(row, idx) {
      this.$confirm(this.$t('returnGoods.confirmCancelPriceChange'), this.$t('returnGoods.tip'))
        .then(res => {
          let operateGoodInfo = {
            index: idx,
            alterGoodsWay: '1',
            barCode: row.barCode,
            isNoUpdatePrice: 'Y'
          }
          this.operateList(operateGoodInfo)
        })
        .catch(() => {})
    },
    operateList(operateGoodInfo) {
      this.fetchLoading = true
      let reqData = {
        operationOrderType: '1',
        orderId: this.invoicesItem.id
      }
      if (operateGoodInfo) {
        reqData['operateGoodInfo'] = operateGoodInfo
      }
      if (this.goodInfos && this.goodInfos.length) {
        reqData['goodInfos'] = this.goodInfos
      }
      if(this.couponRetreatInfos.length){
        reqData['couponRetreatInfos'] = this.couponRetreatInfos
      }
      salesAfterOperate(reqData)
        .then(res => {
          this.goodInfos = JSON.parse(JSON.stringify(res.goodInfos))
          if(res.couponRetreatInfos && res.couponRetreatInfos.length){
            this.couponRetreatInfos = res.couponRetreatInfos
            this.tableData = [...res.goodInfos, ...res.couponRetreatInfos]
          }else{
            this.couponRetreatInfos = []
            this.tableData = res.goodInfos
          }
          this.reduceResult = res.reduceResult
          this.hasAlterPriceInfo = res.hasAlterPriceInfo
          if (!this.hrFlowTypeId) {
            this.hrFlowTypeId = res.hrFlowTypeId
          }
          if (!this.isAllowNegativeStocks) {
            this.isAllowNegativeStocks = res.isAllowNegativeStocks
          }
          if (res && res.message && res.message !== '') {
            this.$message.error(res.message)
          }
          this.setChecked()
          this.fetchLoading = false
        })
        .catch(error => {
          GridManager.renderGrid(this.gridOption.gridManagerName)
          this.setChecked()
          this.fetchLoading = false
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
        })
    },

    showAll(item, type) {
      this.activeObject = item
      if(type === 'act'){
        this.activeInfoVisible = true
      }else{
        this.activeObject = this.couponOrderDetailPojoList.find(obj =>{
          return obj.certificateId === item.certificateId
        })
        this.TicketGoodsLog = true
      }
    },
    showInfo(row){
      this.activeObject = this.ticketInfoList.find(item=>{
        return item.certificateId === row.certificateId
      })
      this.TicketGoodsLog = true
    },

    submitBefore() {
      this.approveList = []
      let checkList = GridManager.getCheckedData(this.gridOption.gridManagerName)
      if (!checkList.length) {
        return this.$message({ showClose: true, message: this.$t('returnGoods.selectGoodsTip'), type: 'error', duration: 2000 })
      }
      if (!this.description) {
        return this.$message({ showClose: true, message: this.$t('returnGoods.fillReasonTip'), type: 'error', duration: 2000 })
      }
      this.approveList = this.tableData.filter(item => {
        return item.isUpdatePrice === 'Y' && item.isSelect === 'Y'
      })
      if (this.approveList.length) {
        let tipList = this.approveList.map(item => {
          return item.goodsNo + '/' + item.goodsName
        })
        const confirmText = [this.$t('returnGoods.priceChangeExceedTip'), ...tipList]
        const newDatas = []
        const h = this.$createElement
        for (const i in confirmText) {
          newDatas.push(h('p', null, confirmText[i]))
        }
        this.$confirm(this.$t('returnGoods.priceChangeReminder'), {
          title: this.$t('returnGoods.priceChangeReminder'),
          message: h('div', null, newDatas)
        })
          .then(() => {
            this.approveInfo = {
              ...this.otherInfo,
              remark: this.description,
              orderId: this.invoicesItem.id,
              orderTypeId: this.invoicesItem.orderTypeId
            }
            this.changePriceVisible = true
          })
          .catch(() => {})
      } else {
        if (this.otherInfo.isPublic === 'Y' || this.otherInfo.crmPhone || this.couponOrderDetailPojoList.length) {
          let str = `<div style="color: #000;margin-bottom: 10px;">{{${this.$t('returnGoods.confirmInfoTip')}}</div>{{${this.$t('returnGoods.attention')}}：<br/>`
          if (this.otherInfo.isPublic === 'Y') {
            str = str + `${this.$t('returnGoods.publicOrderTip')}<br/>`
          }
          if (this.otherInfo.crmPhone) {
            str = str + `${this.$t('returnGoods.memberOrderTip')}<br/>`
          }
          if(this.couponOrderDetailPojoList.length){
            str = str + `${this.$t('returnGoods.thirdPartyCouponTip')}<br/>`
          }
          this.$confirm(str, this.$t('returnGoods.confirmReturnTitle'), {
            dangerouslyUseHTMLString: true
          }).then(() => {
            this.sureSubmit()
          }).catch(() => {})
        } else {
          this.sureSubmit()
        }
      }
    },
    sureSubmit() {
      this.fetchLoading = true
      let reqData = {
        remark: this.description,
        goodInfos: this.goodInfos,
        orderId: this.invoicesItem.id,
        reduceResult: this.reduceResult,
        hasAlterPriceInfo: this.hasAlterPriceInfo,
        orderTypeId: this.invoicesItem.orderTypeId
      }
      const cashierItem = JSON.parse(this.$cache.local.get('cashierDeskItem'))
      if (cashierItem) {
        reqData['terminalId'] = cashierItem.id
      }
      if(this.couponRetreatInfos.length){
        reqData['couponRetreatInfos'] = this.couponRetreatInfos
      }
      returnSalesSubmit(reqData)
        .then(res => {
          this.salesVisible = false
          this.$emit('refresh')
          this.fetchLoading = false
        })
        .catch(error => {
          this.fetchLoading = false
          this.$message({ showClose: true, message: error, type: 'error', duration: 2000 })
        })
    },
    approveSubmit() {
      this.salesVisible = false
      this.$emit('refresh')
    }
  }
}
</script>

<style lang="scss" scoped>
.close-icon {
  color: #999;
  padding: 10px;
  margin-right: -10px;
  cursor: pointer;
}
.return-box {
  padding: 10px;
  position: relative;
  .return-table {
    width: calc(100% - 410px);
  }
  .info-right {
    width: 400px;
    margin-left: 10px;
    .active-list {
      background: #f5f5f5;
      padding: 10px;
      border-radius: 6px;
      margin-bottom: 15px;
      .active-info {
        background: #fff;
        margin-bottom: 10px;
        border-radius: 4px;
        &:last-child {
          margin-bottom: 0;
        }
        p {
          padding: 10px 0 10px 10px;
          border-bottom: 1px solid #eee;
          span {
            font-weight: bold;
            margin-bottom: 5px;
            color: rgb(255, 144, 0);
          }
          i {
            color: #000;
            font-style: normal;
          }
        }
        .active-goods {
          padding: 8px 10px 2px;
          .goods-all{
            width: 300px;
            overflow: hidden;
          }
          .goods-relative {
            width: 86px;
            flex-shrink: 0;
            margin-right: 10px;
            position: relative;
            overflow: hidden;
            &:last-child {
              margin-right: 0;
            }
            .goods-image {
              width: 86px;
              height: 80px;
              border-radius: 4px;
              float: left;
              background: #eee;
              color: #999;
              font-size: 8px;
            }
            .active-num {
              position: absolute;
              left: 0;
              bottom: 19px;
              font-size: 10px;
              color: #fff;
              background: #999;
              padding: 2px 6px;
              border-radius: 0 4px 0 4px;
            }
            .active-type {
              position: absolute;
              right: -31px;
              top: 12px;
              width: 100px;
              height: 18px;
              line-height: 18px;
              font-size: 8px;
              text-align: center;
              color: #fff;
              transform: rotate(45deg);
            }
          }
        }
      }
    }
    .return-info {
      color: #000;
      padding: 10px;
      border-radius: 6px;
      margin-bottom: 20px;
      position: relative;
      background: rgb(255, 247, 230);
      box-shadow: 0 0 6px 0 rgba(4, 51, 97, 0.29);
      .return-tips {
        position: absolute;
        right: 5px;
        top: 6px;
        font-size: 16px;
        color: red;
        font-weight: bold;
      }
      .return-title {
        font-size: 18px;
        margin-bottom: 10px;
      }
      .info-line {
        line-height: 22px;
        color: #666;
        .public-order {
          margin-left: 30px;
          border-radius: 4px;
          font-size: 12px;
          line-height: 16px;
          padding: 0 8px;
          color: rgb(250, 140, 22);
          background: rgb(255, 231, 186);
          border: 1px solid rgb(250, 140, 22);
        }
      }
      .old-money {
        color: #666;
        font-size: 15px;
        margin-top: 10px;
        padding-bottom: 8px;
        i {
          font-style: normal;
          color: red;
          font-size: 18px;
        }
      }
      .border-bottom {
        border-bottom: 1px solid #ddd;
      }
      .return-reason {
        p {
          margin-top: 10px;
          margin-bottom: 5px;
          font-size: 15px;
          color: #666;
          span {
            color: red;
          }
        }
      }
    }
    .return-btn {
      width: 100%;
      font-size: 16px;
      line-height: 20px;
    }
  }
}
.table-style {
  border: 1px solid #eee;
  .change-img {
    width: 80px;
    height: 80px;
    border-radius: 4px;
    color: #999;
    background: #eee;
    float: left;
  }
  .change-info {
    text-align: left;
    margin-left: 10px;
    height: 80px;
    p {
      font-size: 16px;
      color: #000;
    }
  }
  .color-size {
    border: 1px solid #eee;
    padding: 5px 0;
  }
  .red-text {
    color: red;
  }
  .change-goods {
    color: #fff;
    cursor: pointer;
    background: #0b83f3;
    padding: 5px 10px;
    border-radius: 2px;
  }
  .table-table {
    width: 70%;
    margin-left: 15%;
  }
}
.activity {
  background: linear-gradient(-90deg, #ec4620, #f08702, #f7d400) !important;
}
.gift {
  background: linear-gradient(0deg, #208aec, #02d7f0, #00c6f7) !important;
}
.add-buy {
  background: linear-gradient(0deg, rgb(116, 47, 169), rgb(101, 41, 147), rgb(72, 30, 105)) !important;
}
</style>
